import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { Tag } from '@fiverr-private/data_display';
import { JobArrow } from '../../icons';
import { appTranslate, departmentLabel } from '../../i18n';
import { Job } from '../../../lib/comeet';
import { useBI, useImpression } from '../../bi';

export const OpenPositionCard = ({ uid, title, department, location, encodedId }: Job) => {
    const bi = useBI();
    const impressionRef = useImpression<HTMLAnchorElement>(() =>
        bi.reportPositionImpression({ positionUid: uid, positionTitle: title })
    );

    return (
        <Stack
            as="a"
            ref={impressionRef}
            href={pathfinder('jobs_page_jobs_sub_domain', { sub_domain: encodedId })}
            onClick={() => bi.reportPositionClick({ positionUid: uid, positionTitle: title })}
            direction={{ default: 'column', md: 'row' }}
            justifyContent={{ md: 'spaceBetween' }}
            alignItems={{ default: 'flexStart', md: 'center' }}
            gap={{ default: '4', md: '0' }}
            width="100%"
            paddingX={{ default: '5', md: '6' }}
            paddingY={{ default: '5', md: '6' }}
            background="#fff"
            cursor="pointer"
            style={{
                border: '1px solid #e4e5e7',
                borderRadius: 24,
                textDecoration: 'none',
            }}
        >
            <Typography
                as="p"
                color="black"
                size="h_md"
                fontWeight="bold"
                letterSpacing="-1.5px"
                hidden={{ default: false, md: true }}
                style={{ lineHeight: 0.9 }}
            >
                {title}
            </Typography>
            <Typography
                as="p"
                color="black"
                size="h_lg"
                fontWeight="normal"
                letterSpacing="-1.5px"
                hidden={{ default: true, md: false }}
                style={{ lineHeight: 0.9 }}
            >
                {title}
            </Typography>

            <Stack
                direction="row"
                alignItems="center"
                justifyContent={{ default: 'spaceBetween', md: 'flexEnd' }}
                gap={{ default: '4', md: '16' }}
                width={{ default: '100%', md: 'auto' }}
            >
                <Stack as="span" direction="row" gap="2" alignItems="center">
                    {departmentLabel(department) && (
                        <Tag variant="filled" size="sm">
                            {departmentLabel(department)}
                        </Tag>
                    )}

                    {location && (
                        <Tag variant="filled" size="sm">
                            {location}
                        </Tag>
                    )}
                </Stack>
                <Stack
                    alignItems="center"
                    justifyContent="center"
                    width="31px"
                    height="31px"
                    background="#000"
                    borderRadius="circle"
                    flexShrink={0}
                    aria-label={appTranslate('job_card.view_job') as string}
                >
                    <Typography as="span" width="17px" height="auto">
                        <JobArrow />
                    </Typography>
                </Stack>
            </Stack>
        </Stack>
    );
};
